<form [formGroup]="form" autocomplete="off">
  <div class="row">
    <!-- thenConditionType -->
    <div class="tw-w-full">
      <enum-select-search
        enumName="TextParserThenConditionType"
        [label]="fields + 'thenConditionType'"
        [control]="form?.get('thenConditionType')"
        [value]="thenConditionType"
        (valueChange)="onChangeThenConditionType($event); onCreateJson()"
        (onError)="onClose()"
      >
      </enum-select-search>
    </div>

    <!-- thenConditionValue -->
    <div class="tw-w-full"></div>

    <!-- privateNumberId -->
    <div *ngIf="isShowPrivateNumber" class="tw-w-full">
      <private-number-select-search
        [label]="fields + 'senderNumber'"
        [control]="form?.get('privateNumberId')"
        [sendType]="
          thenConditionType ==
            TextParserThenConditionType.SendReceivedSmsToPhonebook ||
          thenConditionType == TextParserThenConditionType.SendSmsToPhonebook
            ? SendTypes.Phonebook
            : SendTypes.Single
        "
        [(value)]="model.privateNumberId"
        (valueChange)="onCreateJson()"
      >
      </private-number-select-search>
    </div>

    <!-- mobileNumber -->
    <div *ngIf="isShowMobileNumber" class="tw-w-full">
      <form-field
        class="tw-w-full"
        [(value)]="model.mobileNumber"
        (valueChange)="onCreateJson()"
        [control]="form?.get('mobileNumber')"
        [label]="fields + 'mobileNumber'"
        classList="dir-ltr"
      >
      </form-field>
    </div>

    <!-- SentDelayType & SentDelayValue-->
    <div *ngIf="isShowSentDelayType" class="tw-w-full">
      <app-periodic-type
        [config]="periodicTypeConfig"
        (periodType)="model.sentDelayType = $event; onCreateJson()"
        (periodText)="model.sentDelayValue = $event; onCreateJson()"
      >
      </app-periodic-type>
    </div>

    <!--sms body & privateNumber -->
    <div *ngIf="isShowSmsBody" class="tw-w-full">
      <app-sms-body
        [form]="form"
        [isEditMode]="formPageConfig.isEditMode"
        smsBodyControlName="smsBody"
        senderNumberControlName="privateNumberId"
        [isAddSignature]="false"
        [isAddHeader]="false"
        [senderNumberId]="model.privateNumberId"
        [smsBody]="smsBody"
        [sendType]="
          thenConditionType ==
            TextParserThenConditionType.SendReceivedSmsToPhonebook ||
          thenConditionType == TextParserThenConditionType.SendSmsToPhonebook
            ? SendTypes.Phonebook
            : SendTypes.Single
        "
        (finalSmsBody)="model.smsBody = $event; onCreateJson()"
        (senderNumberId)="model.privateNumberId = $event; onCreateJson()"
      >
      </app-sms-body>
    </div>

    <!-- senderPhonebook -->
    <div *ngIf="isShowSenderPhonebook" class="tw-w-full">
      <phonebook-select-search
        type="phonebooksListForServices"
        label="common.group"
        [control]="form?.get('phonebookId')"
        [(value)]="model.phonebookId"
        (valueChange)="onCreateJson()"
      >
      </phonebook-select-search>
    </div>

    <!-- email -->
    <div *ngIf="isShowEmail" class="tw-w-full">
      <form-field
        class="tw-w-full"
        [(value)]="model.email"
        (valueChange)="onCreateJson()"
        [control]="form?.get('email')"
        [label]="fields + 'email'"
        classList="dir-ltr"
      >
      </form-field>
    </div>

    <!-- phonebooks -->
    <div *ngIf="isShowPhonebooks" class="tw-w-full tw-my-5">
      <h3 class="tw-mr-3">{{ "common.group" | translate }}</h3>
      <phonebook-selection-list
        searchLabel="common.search"
        type="phonebooksListForServices"
        (values)="model.phonebookIds = $event; onCreateJson()"
        [values]="model.phonebookIds"
        responsiveClass="tw-w-full"
        searchBoxGridclass="tw-w-full"
        [isSmallSize]="true"
      >
      </phonebook-selection-list>
    </div>

    <!-- matching DynamicTemplateId -->
    <div *ngIf="isShowDynamicTemplateId" class="tw-w-full">
      <dynamic-template-select-search
        class="tw-mt-4"
        [label]="fields + 'matchingDynamicTemplateId'"
        [control]="form?.get('matchingDynamicTemplateId')"
        [(value)]="model.matchingDynamicTemplateId"
        (valueChange)="onCreateJson()"
      >
      </dynamic-template-select-search>
    </div>

    <!-- no Matching DynamicTemplateId -->
    <div *ngIf="isShowDynamicTemplateId" class="tw-w-full">
      <dynamic-template-select-search
        class="tw-mt-4"
        [label]="fields + 'noMatchingDynamicTemplateId'"
        [control]="form?.get('noMatchingDynamicTemplateId')"
        [(value)]="model.noMatchingDynamicTemplateId"
        (valueChange)="onCreateJson()"
      >
      </dynamic-template-select-search>
    </div>

    <!-- webhook -->
    <div *ngIf="isShowWebhook" class="tw-w-full tw-mt-3">
      <webhook-select-search
        class="tw-mt-4"
        [control]="form?.get('webhookAddress')"
        [value]="model?.webhookId"
        (itemChange)="onSelectWebhook($event)"
      >
      </webhook-select-search>
    </div>
  </div>
</form>
